/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonTokenSummaryInfo = {
    TKNK: string;
    TKNTP: BabylonTokenSummaryInfo.TKNTP;
    NN: string;
    SB: string;
    IMG: string;
};

export namespace BabylonTokenSummaryInfo {

    export enum TKNTP {
        CW20 = 'CW20',
        IBC = 'IBC',
        NATIVE = 'NATIVE',
    }


}

